// src/pages/pengamatan/sensus-populasi-anakan-pisang/SensusPopulasiAnakanPisangFilterCard.jsx
import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Typography,
  Divider,
  Box
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

const SensusPopulasiAnakanPisangFilterCard = ({
  isFilterOpen,
  statusFilter,
  dateSort,
  onStatusFilterChange,
  onDateSortChange,
  onResetFilter,
  onApplyFilter
}) => {
  if (!isFilterOpen) {
    return null;
  }

  return (
    <Card sx={{ mb: 2, border: '1px solid', borderColor: 'primary.main' }}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <FilterListIcon color="primary" />
          <Typography variant="h6" component="h3" color="primary">
            Filter Data
          </Typography>
        </Stack>

        <Grid container spacing={3} alignItems="center">
          {/* Filter Status Pengamatan */}
          <Grid item xs={12} md={4}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="status-filter-label">Status Pengamatan</InputLabel>
              <Select
                labelId="status-filter-label"
                value={statusFilter}
                onChange={(e) => onStatusFilterChange(e.target.value)}
                label="Status Pengamatan"
              >
                <MenuItem value="">
                  <em>Semua Status</em>
                </MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Processed">Processed</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Filter Sorting Tanggal */}
          <Grid item xs={12} md={4}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="date-sort-label">Urutan Tanggal</InputLabel>
              <Select
                labelId="date-sort-label"
                value={dateSort}
                onChange={(e) => onDateSortChange(e.target.value)}
                label="Urutan Tanggal"
              >
                <MenuItem value="ascending">Ascending (Terlama - Terbaru)</MenuItem>
                <MenuItem value="descending">Descending (Terbaru - Terlama)</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Tombol Aksi */}
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={onResetFilter}
                color="secondary"
              >
                Reset
              </Button>
              <Button
                variant="contained"
                onClick={onApplyFilter}
                color="primary"
              >
                Terapkan Filter
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* Info Filter Aktif */}
        <Box sx={{ mt: 2 }}>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Filter Aktif: 
            {statusFilter && ` Status: ${statusFilter}`}
            {dateSort && `, Urutan: ${dateSort === 'ascending' ? 'Terlama ke Terbaru' : 'Terbaru ke Terlama'}`}
            {!statusFilter && !dateSort && ' Tidak ada filter aktif'}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SensusPopulasiAnakanPisangFilterCard;